var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"footer-menu",attrs:{"aria-label":"Footer Menu"}},[_c('ul',{attrs:{"role":"menu"}},_vm._l((_vm.footerNavigation),function(navItem,index){return _c('NavigationItem',{key:index,attrs:{"css-class-li":"","css-class":"","navitem":navItem}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }